<template>
    <div>
        <p
            v-if="footer.withCategories"
            :style="{ color: footer.fontColor }"
            class="px-6 mb-0 sm:mb-2 text-base font-semibold uppercase"
        >
            <cUtilsEdit @edit="goToCategoryField(category.id, 'categoryName')">
                <span> {{ category.name }}</span>
            </cUtilsEdit>
        </p>
        <div class="flex flex-col">
            <a
                v-for="(link, index) in categoryLinks"
                :key="index"
                :href="link.url"
                @click.prevent="goToLink(link.url)"
                :style="{ color: footer.fontColor }"
                class="footer-link px-6 py-1 text-base"
            >
                <cUtilsEdit @edit="goToLinkField(link.id, 'linkName')">
                    <span> {{ link.name }}</span>
                </cUtilsEdit>
            </a>
        </div>
    </div>
</template>

<script>
import { useLegalGoTo } from "@/views/tools/legal/utils/useLegalGoTo";
import { useGoToLink } from "@/shared/utils/router/useGoToLink";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

export default {
    name: "cCategory",
    props: {
        footer: Object,
        category: Object,
    },
    setup() {
        const { goToLink } = useGoToLink();
        const { goToLinkField, goToCategoryField } = useLegalGoTo();
        return {
            goToLink,
            goToLinkField,
            goToCategoryField,
        };
    },
    components: {
        cUtilsEdit,
    },
    computed: {
        categoryLinks() {
            const notDeleted = this.category.links.filter((l) => !l._deleted);
            return notDeleted;
        },
    },
};
</script>
